@if(isPageRestrictionLoaded){
<div class="ppl-container-body">
  <div class="ppl-container no-margin">
    <div class="ppl-content-container no-left-padding" style="max-height: calc(100vh - 140px); box-sizing: border-box;">
      <div class="line1">

        <div class="action">
          <ppl-button [label]="backLabel" (click)="navigateToLeads()" icon="fa fa-chevron-left"
            [customClass]="'primary-button semi-rounded'" [iconPosition]="'left'"></ppl-button>
        </div>

        <div class="actGRP">
          @if((entry === 'providerEnrollment' || entry === 'participantEnrollment') && showSurveyBtn){
            <ppl-button label="Survey" icon="fa fa-clipboard" [customClass]="'ghost-button'"
            [iconPosition]="'left'" (click)="openSurvey()"
            *authorize="[pageId, tabId, 'survey', 'button']"></ppl-button>
          }
          <ppl-button label="Communication Logs" icon="fa fa-comments-o" [customClass]="'ghost-button'"
            [iconPosition]="'left'" (click)="communicationLogs()"
            *authorize="[pageId, tabId, 'communication_logs', 'button']"></ppl-button>

          <ppl-button label="History" icon="fa fa-history" [customClass]="'ghost-button'" [iconPosition]="'left'"
            *authorize="[pageId, tabId, 'change_history', 'button']" (click)="getLeadHistory()"></ppl-button>

          <ppl-button label="Comments" icon="fa fa-comment" [customClass]="'ghost-button'" [iconPosition]="'left'"
            (click)="comments()" *authorize="[pageId, tabId, 'comments', 'button']"></ppl-button>
          <ppl-actions *authorize="[pageId, tabId, 'actions', 'button']" [listButton]="listButton"
            [selectedCheckBoxValue]="applicationData" [sourcePage]="entry" (leadUpdated)="getUpdatedLeadData($event)"
            [from]="'details'"></ppl-actions>
        </div>
      </div>
      <div class="line2">
        <img class="profile" src="../../assets/images/account_circle_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24.svg"
          alt="User profile image" height="48px">
        <h2>Details for {{ filledInfo?.fname }}</h2>
      </div>

      <div style="width: 100%; box-sizing: border-box;">

        <!-- <ppl-tabbed-panel [horizontalMenuItemstoDisplay]="horizontalMenuItemstoDisplay">
    
  </ppl-tabbed-panel> -->



        <div class="ppl-tabs">
          <!-- Button for Collapsing Menu (Visible only on Mobile) -->
          <div class="d-flex flex-row-reverse">
            <ppl-button label="Expand Menu" icon="fa fa-bars" [customClass]="'d-md-none primary-button mb-2'" [iconPosition]="'left'"
              *authorize="[pageId, tabId, 'ExpandMenu', 'button']" data-bs-toggle="collapse"
              data-bs-target="#mobileMainMenu" aria-expanded="false" aria-controls="mobileMainMenu"></ppl-button>
          </div>

          <!-- Collapsible Menu (visible on mobile when toggled) -->
          <div class="ppl-nav ppl-nav-tabs collapse d-md-flex" id="mobileMainMenu" #mobileMainMenu role="tablist">
            <div *ngFor="let menuItem of horizontalMenuItemstoDisplay;" class="ppl-nav-item">
              <a #tabButton class="ppl-nav-link" [ngClass]="{'single-tab': horizontalMenuItemstoDisplay.length === 1}"
                [class.active]="menuItem.menu_id === selectedMenuItem" role="tab" (click)="onMenuSelection(menuItem); focusTabPanel()"
                href="javascript:void(0)">
                {{ menuItem.menu_label }}
              </a>
            </div>
          </div>
          
          <!-- Tab Content -->
          <div class="tab-content" role="tabpanel" tabindex="-1"
          [attr.id]="'tabpanel-' + selectedMenuItem"
          [attr.aria-labelledby]="'tab-' + selectedMenuItem"
          (keydown)="onPanelKeydown($event)"
          #tabPanel>
            <router-outlet></router-outlet>
          </div>
        </div>

      </div>

      <ppl-side-drawer [width]="'1100px'" *authorize="[pageId, tabId, 'change_history', 'button']"
        [(isSideDrawerVisible)]="isCommunicationLogs" [title]="'Communication Logs'"
        (close)="isCommunicationLogs = false">
        <ppl-communication-logs [sourcePage]="entry" [leadId]="id" [program]="program.program_code"
          [isCommunicationLogs]="isCommunicationLogs"></ppl-communication-logs>
      </ppl-side-drawer>

      @if(entry === 'providerEnrollment' || entry === 'participantEnrollment'){
      <ppl-side-drawer [width]="'1100px'" *authorize="[pageId, tabId, 'survey', 'button']"
        [(isSideDrawerVisible)]="showSurvey" [title]="'Survey'"
        (close)="showSurvey = false">
        <ppl-survey [entry]="entry" [recordId]="id"></ppl-survey>
      </ppl-side-drawer>
      }

      <ppl-side-drawer *authorize="[pageId, tabId, 'change_history', 'button']" [(isSideDrawerVisible)]="isAuditHistory"
        [title]="'Audit History'" (close)="isAuditHistory = false">
        <ppl-timeline [data]="auditHistory"></ppl-timeline>
      </ppl-side-drawer>

      @if(filledInfo){

      <ppl-side-drawer [width]="'800px'" *authorize="[pageId, tabId, 'comments', 'button']"
        [(isSideDrawerVisible)]="enableComments" [title]="'Comments'" (close)="enableComments = false">
        <ppl-lead-comments [sourcePage]="entry" [sectionData]="steps" [leadId]="id" [program]="program.program_code"
          (leadUpdated)="getUpdatedLeadData($event)" [clearComments]="enableComments"></ppl-lead-comments>
      </ppl-side-drawer>

      }
      <ppl-notification-sms [show]="showSMSModal" [notificationType]="notificationType"
        (onHandleCancel)="onHandleCancel($event)" [selectedCheckBoxValue]="applicationData"
        [sourcePage]="'details'"></ppl-notification-sms>
    </div>
  </div>
</div>
}